/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionnaireQuestion } from './QuestionnaireQuestion';
import {
    QuestionnaireQuestionFromJSON,
    QuestionnaireQuestionFromJSONTyped,
    QuestionnaireQuestionToJSON,
    QuestionnaireQuestionToJSONTyped,
} from './QuestionnaireQuestion';

/**
 * 
 * @export
 * @interface QuestionnaireQuestions
 */
export interface QuestionnaireQuestions {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireQuestions
     */
    version: string;
    /**
     * 
     * @type {Array<QuestionnaireQuestion>}
     * @memberof QuestionnaireQuestions
     */
    questions: Array<QuestionnaireQuestion>;
}

/**
 * Check if a given object implements the QuestionnaireQuestions interface.
 */
export function instanceOfQuestionnaireQuestions(value: object): value is QuestionnaireQuestions {
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('questions' in value) || value['questions'] === undefined) return false;
    return true;
}

export function QuestionnaireQuestionsFromJSON(json: any): QuestionnaireQuestions {
    return QuestionnaireQuestionsFromJSONTyped(json, false);
}

export function QuestionnaireQuestionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireQuestions {
    if (json == null) {
        return json;
    }
    return {
        
        'version': json['version'],
        'questions': ((json['questions'] as Array<any>).map(QuestionnaireQuestionFromJSON)),
    };
}

export function QuestionnaireQuestionsToJSON(json: any): QuestionnaireQuestions {
    return QuestionnaireQuestionsToJSONTyped(json, false);
}

export function QuestionnaireQuestionsToJSONTyped(value?: QuestionnaireQuestions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'version': value['version'],
        'questions': ((value['questions'] as Array<any>).map(QuestionnaireQuestionToJSON)),
    };
}

